import { useNovaObra } from "../hooks/nova-obra.context";
import type { NovaObraEtapa } from "../hooks/nova-obra.types";

const ETAPA_DADOS_OBRA: NovaObraEtapa = 1;
const ETAPA_DURACAO: NovaObraEtapa = 2;
const ETAPA_TIPOS: NovaObraEtapa = 3;
const ETAPA_EQUIPE: NovaObraEtapa = 4;

/** "Editar" de cada seção volta à etapa dela sem perder dados. */
export function useEtapaRevisao() {
  const { irParaEtapa } = useNovaObra();

  return {
    editarDadosObra: () => irParaEtapa(ETAPA_DADOS_OBRA),
    editarDuracao: () => irParaEtapa(ETAPA_DURACAO),
    editarTipos: () => irParaEtapa(ETAPA_TIPOS),
    editarEquipe: () => irParaEtapa(ETAPA_EQUIPE),
  };
}
